export function isValidEmail(email: unknown): email is string {
  if (typeof email !== 'string') return false;
  const cleanedEmail = email.replace(/\s+/g, '');
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(cleanedEmail);
}

export function normalizeEmail(email: string): string {
  if (typeof email !== 'string') {
    throw new Error('Email must be a string.');
  }
  return email.replace(/\s+/g, '').toLowerCase();
}

/** Mirrors the indexed PostgreSQL clean_phone normalization. */
export function normalizePhone(phone: string): string | null {
  if (!phone || phone.trim() === '') return null;

  let cleaned = phone.replace(/\.0$/g, '').replace(/\D/g, '');
  if (cleaned.length === 0) {
    throw new Error(`Invalid phone: "${phone}". After removing non-digit characters the phone is empty.`);
  }

  if (cleaned.length === 10) {
    if (cleaned.startsWith('1')) {
      throw new Error(`Invalid phone: "${phone}". 10-digit numbers cannot start with "1". Did you mean to enter an 11-digit number?`);
    }
    cleaned = `1${cleaned}`;
  } else if (cleaned.length === 11) {
    if (!cleaned.startsWith('1')) {
      throw new Error(`Invalid phone: "${phone}". 11-digit phone numbers must start with a "1".`);
    }
  } else {
    throw new Error(`Invalid phone: "${phone}". Must be 10 or 11 digits (including country code).`);
  }

  if (!/^\d+$/.test(cleaned)) {
    throw new Error(`Invalid phone: "${phone}". Must contain only digits.`);
  }
  return cleaned;
}

export function isValidPhone(phone: string): boolean {
  try {
    return normalizePhone(phone) !== null;
  } catch {
    return false;
  }
}
